import PropTypes from 'prop-types';
import React from 'react';
var schoolLicence = 'TES-PAID-SCHOOL';
var schoolLicenceUpgrade = 'TES-PAID-SCHOOL-UPGRADE';
var individualLicence = 'TES-PAID';
var licenceTypes = {
  individual: 'INDIVIDUAL LICENCE',
  school: 'SCHOOL LICENCE'
};

var determineLicenceType = function determineLicenceType(licenceArray) {
  if (licenceArray.includes(schoolLicence) || licenceArray.includes(schoolLicenceUpgrade)) return licenceTypes.school;
  if (licenceArray.includes(individualLicence)) return licenceTypes.individual;
  return '';
};

var LicenceType = function LicenceType(_ref) {
  var licences = _ref.licences;
  return /*#__PURE__*/React.createElement("span", {
    className: "licence-type"
  }, determineLicenceType(licences));
};

LicenceType.displayName = "LicenceType";
LicenceType.propTypes = {
  licences: PropTypes.arrayOf(PropTypes.string)
};
export default LicenceType;